export default __webpack_public_path__ + "static/media/portfolio-140.1e3eaa66.jpg";